// imports remain exactly the same
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Col, Row } from "react-bootstrap";

import Input from "../../components/form/inputs/Input";
import TillLogin from "../../components/login/staff-number-login";
import LoaderButton from "../../components/LoaderButton";
import RealTimeAgent from "../../components/mqtt/MqttAgent";

import { getFulfillerData, validateCollectShipment } from "../../actions/ShippingActionsNew";
import { errorNotification, removeNotification } from "../../actions/NotificationActions";

const mapStateToProps = state => ({
    user: state.authState,
    loading: state.shippingState.isLoading,
    fulfiller: state.shippingState.fulfiller,
    loggedIn: state.shippingState.loggedIn,
    errors: state.notificationState.errors
});

const mapDispatchToProps = dispatch => ({
    getFulfillerData: (futuraId) => dispatch(getFulfillerData(futuraId)),
    validateCollectShipment: (barcodes, collectionCode) =>
        dispatch(validateCollectShipment( barcodes, collectionCode )),
    errorNotification: (message) => dispatch(errorNotification(message)),
    removeNotification: (message) => dispatch(removeNotification(message))
});

class Collect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: false,
            barcodes: [''],  // start with one barcode input
            pinCode: ''
        };
    }

    handleLogin = (fulfiller) => {
        this.props.getFulfillerData(fulfiller);
        this.setState({ loggedIn: true });
    };

    handleBarcodeChange = (index, value) => {
        const newBarcodes = [...this.state.barcodes];
        newBarcodes[index] = value.trim();
        this.setState({ barcodes: newBarcodes });
    };

    addBarcodeInput = () => {
        this.setState(prevState => ({ barcodes: [...prevState.barcodes, ''] }));
    };

    removeBarcodeInput = () => {
        this.setState(prevState => {
            // Never allow removing the last remaining input
            if (prevState.barcodes.length <= 1) {
                return null;
            }
    
            return {
                barcodes: prevState.barcodes.slice(0, -1)
            };
        });
    };
    

    handlePinCodeChange = (e) => {
        this.setState({ pinCode: e.target.value.trim() });
    };

    resetForm = (event) => {
        event.preventDefault();
        this.setState({
            barcodes: [''],
            pinCode: ''
        });
    };

    validateForm = () => {
        const { barcodes, pinCode } = this.state;
        return barcodes.some(b => !b) || !pinCode; // disable if any barcode empty or pin empty
    };

    fulfillShipment = (event) => {
        event.preventDefault();
        const { barcodes, pinCode } = this.state;
        this.props.validateCollectShipment(barcodes, pinCode);
    };

    renderLoggedInView = () => {
        const { loading, fulfiller } = this.props;
        const { barcodes } = this.state;

        return (
            <div className="wrapper">
                <div className="heading">
                    <div className="left-heading">
                        <h1 className="heading-text">Collect Click & Collect Shipment</h1>
                        <h2 className="medium-heading-text">
                            Enter barcodes from the bags and the collection code from the customer's email.
                        </h2>
                    </div>
                </div>

                <Row style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
                    {barcodes.map((barcode, i) => (
                        <Col sm={4} key={i}>
                            <Input
                                id={`barcode-${i}`}
                                name={`barcode-${i}`}
                                label={`Barcode From Bag ${i + 1}`}
                                controlId={`barcode-${i}`}
                                placeholder={`Scan or type barcode from bag ${i + 1}`}
                                onChange={(e) => this.handleBarcodeChange(i, e.target.value)}
                                value={barcode}
                                type="text"
                                autoComplete="off"
                            />
                        </Col>
                    ))}

                    <Col
                        sm={4}
                        style={{
                            marginTop: '8px',
                            display: 'flex',
                            gap: '12px'
                        }}
                    >
                        <LoaderButton type="button" onClick={this.addBarcodeInput} text="Add Another Bag"
                        />

                        <LoaderButton
                            type="button"
                            onClick={this.removeBarcodeInput}
                            disabled={this.state.barcodes.length <= 1}
                            text="Remove Bag"
                        />
                    </Col>


                    <Col sm={4} style={{ marginTop: '16px' }}>
                        <Input
                            id="pin-code"
                            name="pin-code"
                            label="Collection Code"
                            controlId="pin-code"
                            placeholder="Enter collection code from customer email"
                            value={this.state.pinCode}
                            type="text"
                            autoComplete="off"
                            onChange={this.handlePinCodeChange}
                        />
                    </Col>
                </Row>

                <Row style={{ justifyContent: "center", display: "flex", paddingTop: '1rem' }}>
                    <Col sm={4}>
                        <form onSubmit={this.fulfillShipment}>
                            <LoaderButton
                                type="submit"
                                isLoading={loading}
                                disabled={this.validateForm()}
                                text="Confirm Customer Collected"
                            />
                            <a style={{ marginLeft: '24px' }} onClick={this.resetForm}>
                                RESET
                            </a>
                        </form>
                        <p style={{ fontSize: '16px', marginTop: '24px' }}>
                            Clicking confirm sends the customer an email confirmation.
                        </p>
                    </Col>
                </Row>
            </div>
        );
    };

    renderLoginView = () => (
        <div className="wrapper shipping-wrapper">
            <Row style={{ marginBottom: '10px' }}>
                <Col sm={12}>
                    <span style={{ fontSize: '18px', fontWeight: '700', textTransform: 'uppercase' }}>
                        Login to collect shipments
                    </span>
                </Col>
            </Row>
            <Row>
                <TillLogin handleLogin={this.handleLogin} />
            </Row>
            <RealTimeAgent />
        </div>
    );

    render() {
        return (
            <>
                {this.props.loggedIn ? this.renderLoggedInView() : this.renderLoginView()}
            </>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Collect));